require('./signatureDialog.less');

var Marionette = require('marionette'),
    $ = require('jquery'),
    _ = require('underscore'),
    Raphael = require('raphael');


var instanceVars = {
    signatureModel: null
};

/* Note: clicking the canvas will not deselect the edit dialog if it is open -- can only draw one shape so propagation stopped */

module.exports = Marionette.ItemView.extend({

    id: 'signatureDialog',

    template: require('./signatureDialog.hbs'),

    initialize: function(options) {

        _.extend(this, instanceVars, _.pick(options, 'signatureModel'));
    },

    serializeData: function() {

        var signature = this.signatureModel,
            fontHash = signature.fontNamesHash();

        return {
            fontHash: fontHash, /* key by font-face value -- may no longer be necessary */
            showBottomText: signature.get('showBottomText')
        };

    },
    onRender: function() {

        this._checkFontRadio( this.signatureModel.get('activeFont') );

    },

    /* must attach $el before print label */
    onShow: function() {

        this._renderRaphaelFontLabels( this.signatureModel.fontNamesHash() );

    },
    events: {
        'click      .ftInputRow'        : 'fontRowClick',
        'mouseover  .ftInputRow'        : 'onHover',
        'mouseout   .ftInputRow'        : 'onHover',
        'change     #showBottomText'    : 'toggleBottomText'
    },
    toggleBottomText: function(e) {

        var isChecked = $(e.currentTarget).is(':checked');
        this.signatureModel.set('showBottomText', isChecked); //-- triggers (mediate?)

    },
    _renderRaphaelFontLabels: function(fontHash) {

        var baseColor = this.$el.css('color');

        _.each( _.keys(fontHash), function(font) {

            var k = font,
                $div = this.$('.rFontElPlaceHolder[data-font="' + k + '"]'),
                paper = new Raphael($div[0], '100%', '100%'), /* take up space set in css */
                ht = $div.height(),
                fontSize = ht - 5, //ensure fits inside (fonts have diff sizes) .. so it's 5 px less the the css
                LEFT_OFFSET = 4,
                fontEl = paper.print(0 + LEFT_OFFSET,ht/2, k, paper.getFont(k), fontSize).attr({
                    'text-anchor': 'start',
                    fill: this.signatureModel.get('activeFont') === k ? 'black' : baseColor
                });

            $div.data('printedFont', fontEl); //for ref'ing the paper from the div

        }, this);
    },
    _getFontEls: function() {
        return $('.rFontElPlaceHolder').map(function() {
            return $(this).data().printedFont;
        });
    },
    onHover: function(e) {

        var nonSelectedEls =  $('.rFontElPlaceHolder').siblings().not(':checked').map(function() {
            return $(this).siblings().data().printedFont;
        });

        _.each(nonSelectedEls, function(el) {
            el.animate({
                fill: this.$el.css('color'),
                transform: 's1'
            }, 50);
        }, this);

        if (e.type === 'mouseover') {
            var fontEl = $(e.currentTarget).find('.rFontElPlaceHolder').data('printedFont'); //could also forward events to the paper
           // fontEl.animate({ fill: 'black'}, 100, '<'); //todo: would need to be cleaner
            fontEl.animate({
                fill: 'black',
                transform: 's1.1'
            }, 50);
        }

    },
    fontRowClick: function(e) {
        var val = $(e.currentTarget).find('input').val();
        this._unselectAll();
        var fontEl = $(e.currentTarget).find('.rFontElPlaceHolder').data('printedFont'); //could also forward events to the paper
        fontEl.animate({
            fill: 'black',
            transform: 's1.1'
        }, 50);
        this._checkFontRadio(val, fontEl);
        this.signatureModel.set('activeFont', val);
    },
    _checkFontRadio: function(fontName) {
        this.$('input[type="radio"][value="' + fontName + '"]').prop('checked', true);
    },
    _unselectAll: function() {

        var rEls = this._getFontEls();
        _.each(rEls, function(el) {
            el.animate({
                fill: this.$el.css('color'),//(no bold)
                transform: 's1'
            }, 50);
        }, this);

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/signature/dialog/dialog.js
 ** module id = 224
 ** module chunks = 0
 **/